'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const SocketResponse=require('../../../../dist-es6/client/dtos/socketResponse');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;let

TimelineSettingsController=(_class=function(_BaseController){_inherits(TimelineSettingsController,_BaseController);
function TimelineSettingsController($timeout,
uncaughtErrorHandler,
notificationService,
socketService,
uiCommandFactory,
breadcrumbsService,
userService,
displaySettingsService){_classCallCheck(this,TimelineSettingsController);var _this=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler,$timeout));

_this._$timeout=$timeout;
_this._notificationService=notificationService;
_this._socketService=socketService;
_this._uiCommandFactory=uiCommandFactory;
_this._userService=userService;
_this._displaySettingsService=displaySettingsService;

_this._controllerInitialized=!1;

_this._timelineSettingsChangedCommand=_this._uiCommandFactory.make(function(newValue){return _this._updateTimelineSettings(newValue)});

breadcrumbsService.startTrail('Timeline Settings');

_this._loadSettings({reloadFromServer:!1});return _this;
}TimelineSettingsController.prototype.


_updateTimelineSettings=function(){var ref=_asyncToGenerator(function*(use24HourTimeline){
const updateResponse=yield this._socketService.sendAndWaitForResponse('SetTimelineSettings',{use24HourTimeline:use24HourTimeline});

if(!SocketResponse.succeeded(updateResponse)){
this._notificationService.displayNotification('Failed to update timeline settings.','error');
}

yield this._loadSettings({reloadFromServer:!0});
});function _updateTimelineSettings(use24HourTimeline){return ref.apply(this,arguments)}return _updateTimelineSettings}();TimelineSettingsController.prototype.


_loadSettings=function(){var ref=_asyncToGenerator(function*(_ref){let{reloadFromServer:reloadFromServer}=_ref;
_.ensureInstanceOf('boolean',reloadFromServer);

if(reloadFromServer){
const socketResponse=yield this._userService.continueUserSession();
if(!SocketResponse.succeeded(socketResponse)){
this._notificationService.displayNotification('Failed to retrieve timeline settings.','error');
}
}

if(!this._displaySettingsService.isLoaded){

return;
}

this._use24HourTimeline=this._displaySettingsService.use24HourTimeline;
this._controllerInitialized=!0;
this._triggerDigest();
});function _loadSettings(_ref2){let{reloadFromServer:reloadFromServer}=_ref2;return ref.apply(this,arguments)}return _loadSettings}();_createClass(TimelineSettingsController,[{key:'use24HourTimeline',get:function()

{
return this._use24HourTimeline;
},set:function(

use24HourTimeline){
if(typeof use24HourTimeline!='boolean'){
return;
}

this._use24HourTimeline=use24HourTimeline;
this._timelineSettingsChangedCommand.execute(use24HourTimeline);
}}]);return TimelineSettingsController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_updateTimelineSettings',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_updateTimelineSettings'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_loadSettings',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_loadSettings'),_class.prototype)),_class);


module.exports=TimelineSettingsController;
//# sourceMappingURL=timelineSettingsController.js.map
